var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    ref: "galleryViewBox",
    staticClass: "clearfix galleryBox"
  }, [_vm.broadCast || _vm.speakerInfo ? _c('div', {
    staticClass: "TitleBox"
  }, [_c('i', {
    staticClass: "iconfont icon-sound"
  }), _vm._v(_vm._s(_vm.TitleText))]) : _vm._e(), _c('div', {
    staticClass: "pgm",
    class: {
      fullScreen: _vm.isFullScreen
    }
  }, [_c('NewAttendUser', {
    key: "pgm",
    ref: "mainwindowBox",
    staticClass: "is-pgm",
    attrs: {
      "nickName": _vm.behaviorInfo[_vm.pgm.id] || '',
      "title": _vm.sourceType,
      "singChannel": _vm.pgm,
      "isShare": false,
      "rtc": _vm.rtc[_vm.externalParty],
      "outputRtilCode": _vm.outPutRtilCode,
      "controlMute": _vm.returnVal(_vm.pgm),
      "theme": "danger",
      "volume": _vm.voiceList[_vm.pgm.id],
      "showMuteIcons": _vm.broadCast && _vm.broadCast.rtilCode == _vm.outPutRtilCode ? true : false,
      "showOperateBox": false,
      "showChat": _vm.State.showChatMessage,
      "userInfo": _vm.userInfo,
      "degreeHost": _vm.degreeHost[_vm.pgm.id],
      "showTitle": !_vm.pgm.id ? false : true,
      "muteVideo": !_vm.State.cameraStatus[_vm.pgm.id],
      "muteAudio": !_vm.State.micStatus[_vm.pgm.id],
      "isAudioLevel": _vm.audioLevel
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [!_vm.pgm.id ? _c('div', {
    staticClass: "defaultBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))]), _c('div', [_vm._v(_vm._s(_vm.$t('mainWindow.sourceFromWindow')))])]) : _vm._e()]), _c('div', {
    staticClass: "localVideoBox",
    class: {
      active: !_vm.showMe
    }
  }, [_c('NewAttendUser', {
    ref: "localAttentUser",
    staticClass: "is-local",
    attrs: {
      "title": "Me",
      "nickName": _vm.behaviorInfo[_vm.MeInfo.id] || '',
      "isShare": false,
      "singChannel": _vm.MeInfo,
      "talkInfo": _vm.talkInfo,
      "userInfo": _vm.userInfo,
      "volume": _vm.voiceList[_vm.MeInfo.id],
      "muteVideo": !_vm.State.cameraStatus[_vm.MeInfo.id],
      "muteAudio": !_vm.State.micStatus[_vm.MeInfo.id],
      "lockName": _vm.lockName,
      "degreeHost": _vm.degreeHost[_vm.MeInfo.id],
      "liveInfo": _vm.rtilStatusObj[_vm.MeInfo.id] || {},
      "operateList": _vm.operateList,
      "isAudioLevel": _vm.audioLevel
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [_c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  }), _c('div', {
    staticClass: "video-placeholder",
    attrs: {
      "id": "share_stream"
    }
  })]), _c('div', {
    staticClass: "hideVideoBtn",
    on: {
      "click": function ($event) {
        _vm.showMe = !_vm.showMe;
      }
    }
  }, [_c('i', {
    class: _vm.showMe ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
  })])], 1), _vm.talkInfo.rtilCode && _vm.talkStream ? _c('NewAttendUser', {
    staticClass: "talkVideo",
    attrs: {
      "nickName": _vm.talkInfo.name,
      "title": _vm.talkInfo.rtilCode + '',
      "singChannel": _vm.talkStream,
      "isShare": _vm.isShare,
      "shareInfo": _vm.shareInfo,
      "showChat": _vm.State.showChatMessage,
      "volume": _vm.voiceList[_vm.talkInfo.rtilCode],
      "talkInfo": _vm.talkInfo,
      "degreeHost": _vm.degreeHost[_vm.talkInfo.rtilCode],
      "userInfo": _vm.userInfo,
      "isAudioLevel": _vm.audioLevel
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "test",
    staticStyle: {
      "width": "1000px",
      "height": "200px"
    }
  }, _vm._l(_vm.channels, function (channel, key) {
    return _vm.managerRtils.includes(channel.id) || _vm.freeTalk ? _c('NewAttendUser', {
      key: key,
      attrs: {
        "title": _vm.managerRtils.includes(channel.id) ? _vm.$t('commonFunction.host') : _vm.$t('commonFunction.participant'),
        "singChannel": channel,
        "isShare": _vm.isShare,
        "controlMute": _vm.controlMutes[channel.id],
        "volume": _vm.voiceList[channel.id],
        "shareInfo": _vm.shareInfo,
        "showChat": _vm.State.showChatMessage,
        "userInfo": _vm.userInfo,
        "rtc": _vm.rtc[_vm.realPartyCode],
        "isAudioLevel": _vm.audioLevel
      }
    }) : _vm._e();
  }), 1), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _vm._l(_vm.receiveAudioArray, function (channel) {
    return _c('div', {
      key: channel.id,
      staticClass: "audioBox"
    }, [_c('NewAttendUser', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      ref: "remoteHost",
      refInFor: true,
      attrs: {
        "singChannel": channel,
        "muteAudio": _vm.isMute,
        "controlMute": _vm.controlMutes[channel.id],
        "rtc": _vm.rtc[_vm.realPartyCode],
        "title": "host-chat"
      }
    })], 1);
  }), _c('NewAttendUser', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "is-local",
    attrs: {
      "title": "Me",
      "controlMute": true
    }
  }, [_c('div', {
    staticClass: "localVideo",
    attrs: {
      "id": "sendVideo"
    }
  })]), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": _vm.sendToHost
    }
  }), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])]), _c('tipsDailog', {
    staticClass: "micMuted",
    attrs: {
      "info": _vm.showMicMutedInfo,
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "micMutedContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentTitle')))]), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.contentMessage')))]), _c('span', {
    staticClass: "openMicBtn",
    on: {
      "click": _vm.openMicMuted
    }
  }, [_vm._v(_vm._s(_vm.$t('micMutedInfo.openBtnMes')))])])]), _c('guide-page', {
    attrs: {
      "dialogVisible": _vm.State.guideObjShow
    }
  }), _vm.userInfo.rtilCode ? _c('div', {
    staticClass: "chatBox",
    class: {
      fullscreen: _vm.isFullScreen,
      down: _vm.isFullScreen && !_vm.State.showFootBar
    }
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.State.showChatMessage,
      expression: "State.showChatMessage"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.externalJoinInfo.join,
      "showComponent": _vm.State.showChatMessage,
      "nickNameInfo": _vm.behaviorInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e(), _c('Foot', {
    attrs: {
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "rtcLoaded": _vm.rtcLoaded,
      "showUnread": _vm.showUnread,
      "devicesInfo": _vm.devicesInfo,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc[_vm.realPartyCode],
      "showChat": _vm.State.showChatMessage,
      "hasSetRaiseHand": _vm.hasSetRaiseHand,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "showIconArray": ['leaveParty', 'camera', 'mic', 'speaker', 'raiseHand', 'chat'],
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "isHost": false
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };